import React, { useState } from 'react';
import { ChevronDown, ChevronUp, Info } from 'lucide-react';
import { GRADE_SCALE_DISPLAY } from '../../utils/gradeMapping';

const GradeScalePanel = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="mt-8">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="w-full flex items-center justify-between px-6 py-4 bg-slate-50 dark:bg-slate-900 hover:bg-slate-100 dark:hover:bg-slate-800 rounded-2xl transition-colors border border-slate-200 dark:border-slate-800"
      >
        <div className="flex items-center gap-3">
          <Info size={20} className="text-indigo-600 dark:text-indigo-400" />
          <span className="font-bold text-slate-900 dark:text-white">COMSATS Grading Scale</span>
        </div>
        {isOpen ? <ChevronUp size={20} className="dark:text-slate-400" /> : <ChevronDown size={20} className="dark:text-slate-400" />}
      </button>
      
      {isOpen && (
        <div className="mt-4 bg-white dark:bg-slate-900 rounded-2xl border border-slate-200 dark:border-slate-800 overflow-hidden animate-in fade-in slide-in-from-top-2">
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead className="bg-slate-50 dark:bg-slate-800">
                <tr>
                  <th className="px-6 py-3 text-left text-sm font-bold text-slate-700 dark:text-slate-300">Grade</th>
                  <th className="px-6 py-3 text-left text-sm font-bold text-slate-700 dark:text-slate-300">Grade Points</th>
                  <th className="px-6 py-3 text-left text-sm font-bold text-slate-700 dark:text-slate-300">Percentage</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-100 dark:divide-slate-800">
                {GRADE_SCALE_DISPLAY.map((item) => (
                  <tr key={item.grade} className="hover:bg-slate-50 dark:hover:bg-slate-800/50 transition-colors">
                    <td className="px-6 py-3 font-bold text-slate-900 dark:text-white">{item.grade}</td>
                    <td className="px-6 py-3 text-slate-600 dark:text-slate-400">{item.points}</td>
                    <td className="px-6 py-3 text-slate-600 dark:text-slate-400">{item.percent}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
};

export default GradeScalePanel;
